export const TEST_ID = 'warrantyCards';

export const WARRANTY_CARD_DATA = [
    {
        description: 'All hardware should be ready for work',
        subtitle: 'No blockers',
        title: 'Ready'
    },
    {
        description: 'Check the aircraft chassis, props, and motor',
        subtitle: 'hrs until the next inspection',
        title: '50'
    },
    {
        description: 'It may be time to replace the propellers',
        subtitle: 'hrs on Exedy Drone 1',
        title: '250'
    },
    {
        description: 'All hardware should be ready for work',
        subtitle: 'No blockers',
        title: 'Ready'
    },
    {
        description: 'Check the aircraft chassis, props, and motor',
        subtitle: 'hrs until the next inspection',
        title: '50'
    },
    {
        description: 'It may be time to replace the propellers',
        subtitle: 'hrs on Exedy Drone 1',
        title: '250'
    }
];
